import {createApp} from 'vue';
import App from './MediaLibrary.vue';

export default function MediaLibrary(selector) {

  if (!selector || !document.querySelector( selector )) {
    return;
  }

  createApp( App ).mount( selector );
}
